import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AboutImage from "../../../assets/images/feature/about.webp";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const AboutSection = () => {
  const [cmsData, setCmsData] = useState([]);
  const [status, setStatus] = useState(null);
  const [imagePath, setimagePath] = useState([]);

  useEffect(() => {
    fetchCMSData();
  }, []);
  
  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      setCmsData(res.data.data); // Save entire list
      setStatus(res.data.status);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };

  const truncateWords = (html, wordLimit) => {
    const textOnly = html.replace(/<[^>]+>/g, "");
    const words = textOnly.split(" ");
    if (words.length <= wordLimit) return textOnly;
    return words.slice(0, wordLimit).join(" ") + "...";
  };
  const aboutUsItems = cmsData.filter((item) => item.type === "about_us");

  const processedItems = aboutUsItems.map((item) => {
    const fullName = item.name || "";
    const words = fullName.trim().split(" ");
    const lastWord = words.pop();
    const remaining = words.join(" ");
    return {
      ...item,
      lastWord,
      remaining,
    };
  });

  return (
    <>
      {status == 1 ? (
        <section className="about_section py-60">
          <Container>
            {aboutUsItems.map((item, index) => (
              <Row className="align-items-center">
                <Col
                  lg={6}
                  className="order-lg-last md-pl-3 md-pr-3 md-mb-3 order_Second"
                >
                  <div className="img-part">
                    <img
                      src={
                        item?.image ? `${imagePath}${item.image}` : AboutImage
                      }
                      alt="About section"
                      className="img-fluid rounded about_img"
                    />
                  </div>
                </Col>

                <Col lg={6} className="pr-lg-5 md-pr-3">
                  <div className="sec-title">
                    <h6 class="color-primary mb-8">–––– About Us</h6>
                    {processedItems.map((item, index) => (
                      <h2 key={index} className="title mb-3">
                        {item.remaining}{" "}
                        {item.lastWord && (
                          <span className="fm-sec">{item.lastWord}</span>
                        )}
                      </h2>
                    ))}
                    <div className="bold-text mb-4">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: truncateWords(item.description, 100),
                        }}
                      ></p>
                    </div>

                    <motion.div
                      initial={{ opacity: 0, x: 100 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 1, delay: 0.5 }}
                    >
                      <Link to="/About-us" className="educate-btn my-2">
                        <span className="educate-btn__curve"></span>
                        Learn More
                      </Link>
                    </motion.div>
                  </div>
                </Col>
              </Row>
            ))}
          </Container>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default AboutSection;
